export default __webpack_public_path__ + "static/media/space-loop-hd.1ba7bba4.mp4";